import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.rotator = this.el.querySelector('ul');
        this.rotatorItems = this.rotator.querySelectorAll('li');
        this.rotatorIndex = 0;
        this.rotatorPrevIndex = 0;

        this.rotatorTL = gsap.timeline({ repeatDelay: 4, repeat: -1 });
        this.rotatorTL.call(() => { this.updateRotator(); });
    }

    init() {
    }

    updateRotator() {
        let item = this.rotatorItems[this.rotatorIndex];
        
        gsap.to(this.rotator, { width: item.offsetWidth, duration: 0.8, ease: 'power4.out' });

        if (this.rotatorPrevIndex != null) {
            gsap.to(
                this.rotatorItems[this.rotatorPrevIndex],
                { opacity: 0, duration: 0.25, ease: 'none' },
            );
        }
        
        gsap.fromTo(
            item,
            { y: '101%', opacity: 0 },
            { y: '0%', opacity: 1, duration: 0.8, ease: 'power4.out', delay: 0, onComplete: () => {
                this.rotatorPrevIndex = this.rotatorIndex;
                this.rotatorIndex = (this.rotatorIndex == this.rotatorItems.length - 1) ? 0 : this.rotatorIndex + 1;
            } },
        );
    }
}
